// extracted by mini-css-extract-plugin
module.exports = {"container":"Deadlines_container__1g-8B","content":"Deadlines_content__3jhui"};